import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

// 获取足迹列表
export function getCollectionPersonList(query) {
  return request({
    url: BASEROOT + '/collection/collectionPersonList',
    method: 'post',
    data: query
  })
}

// 获取足迹列表 观众
export function getActorTrailList(query) {
  return request({
    url: BASEROOT + '/actorTrail/actorTrailList',
    method: 'post',
    data: query
  })
}

// 获取足迹列表 展品
export function getCollectionProductList(query) {
  return request({
    url: BASEROOT + '/collection/collectionProductList',
    method: 'post',
    data: query
  })
}

// 获取足迹列表 展商
export function getCollectionActorList(query) {
  return request({
    url: BASEROOT + '/collection/collectionActorList',
    method: 'post',
    data: query
  })
}

//展商 观众
export function getRecommendedVisitorList(query) {
  return request({
    url: BASEROOT + '/recommend/exhibitor/getRecommendedVisitorList',
    // url: BASEROOT + '/visitor/exhibitor/getVisitorList',
    method: 'post',
    data: query
  })
}

export function getVisitorRecommendedExhibitorsList(query) {
  return request({
    url: BASEROOT + '/exhibitor/visitor/getExhibitorList',
    method: 'post',
    data: query
  })
}

//展商 搜索观众
export function searchVisitorList(query) {
  return request({
    url: BASEROOT + '/visitor/exhibitor/getVisitorSearchList',
    method: 'post',
    data: query
  })
}





//展商 观众详情
export function getVisitorDetails(query) {
  return request({
    url: BASEROOT + '/visitor/exhibitor/getVisitorDetails',
    method: 'post',
    data: query
  })
}

//热词
export function getSearchTrendInfo(query) {
  return request({
    url: BASEROOT + '/searchTrend/getSearchTrendInfo',
    method: 'post',
    data: query
  })
}